export type TranscriptionProgressStage = 'queued' | 'loading' | 'decoding' | 'transcribing'

export interface TranscriptionProgressSnapshot {
  stage: TranscriptionProgressStage
  progress: number
}

function clampProgress(progress: number): number {
  return Math.max(0, Math.min(1, progress))
}

export function getTranscriptionOverallProgress(snapshot: TranscriptionProgressSnapshot): number {
  const normalizedProgress = clampProgress(snapshot.progress)

  switch (snapshot.stage) {
    case 'queued':
      return 0
    case 'loading':
      return normalizedProgress * 0.35
    case 'decoding':
      return 0.35 + normalizedProgress * 0.35
    case 'transcribing':
      return 0.7 + normalizedProgress * 0.3
  }
}

export function getTranscriptionOverallPercent(snapshot: TranscriptionProgressSnapshot): number {
  return getTranscriptionOverallProgress(snapshot) * 100
}

export function mergeTranscriptionProgress(
  previous: TranscriptionProgressSnapshot | undefined,
  next: TranscriptionProgressSnapshot,
): TranscriptionProgressSnapshot {
  const normalizedNext = {
    stage: next.stage,
    progress: clampProgress(next.progress),
  } satisfies TranscriptionProgressSnapshot

  if (!previous) {
    return normalizedNext
  }

  return getTranscriptionOverallProgress(normalizedNext) >=
    getTranscriptionOverallProgress(previous)
    ? normalizedNext
    : previous
}

export function getTranscriptionStageLabel(stage: TranscriptionProgressStage): string {
  switch (stage) {
    case 'queued':
      return '已排队'
    case 'loading':
      return '正在加载模型'
    case 'decoding':
      return '正在准备音频'
    case 'transcribing':
      return '正在转录'
  }
}
